import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  Checkbox,
  FormControlLabel,
  Typography,
  IconButton
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";

const BE_URI = process.env.REACT_APP_BE_URI;

const CreateTriggerModal = ({
  modalVisible,
  setModalVisible,
  triggers,
  urlToSend,
  token,
  handleReadData,
  buttonColor,
  setIsCreating,
  t
}) => {
  const [status, setStatus] = useState(false);
  const [type, setType] = useState("single");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [weekdays, setWeekdays] = useState({
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false
  });

  const handleConfirm = (selectedDate) => {
    setDate(selectedDate);
  };

  const handleConfirmTime = (selectedTime) => {
    setTime(selectedTime);
  };

  const handleCreateTrigger = async () => {
    try {
      const timestamp = new Date(date).getTime().toString();
      let recurrentData = `${new Date(date).getHours()}:${new Date(date).getMinutes()}`;
      Object.keys(weekdays).forEach((day, index) => {
        if (weekdays[day]) recurrentData += `/${index}`;
      });

      const newTriggerArray = [
        ...triggers,
        {
          status: status ? "on" : "off",
          time: type === "single" ? timestamp : recurrentData
        }
      ];

      const formData = {
        url: urlToSend,
        data: `triggers:${JSON.stringify(newTriggerArray)}`
      };

      setIsCreating(true);
      const res = await axios.post(BE_URI + "/send-data", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });

      setIsCreating(false);
      if (res.data.success) {
        setModalVisible(false);
        setTimeout(() => {
            handleReadData();
        }, 1500);
      } else {
        console.log("Error: " + res.data.message);
      }
      
    } catch (error) {
      setIsCreating(false);
      console.log("Error: " + error);
    }
  };

  const handleWeekdayChange = (day) => {
    setWeekdays({ ...weekdays, [day]: !weekdays[day] });
  };

  const canSend = type == 'single'? date != null : (time && !Object.values(weekdays).every(value => value === false));

  return (
    <Dialog open={modalVisible} onClose={() => setModalVisible(false)} fullWidth >
      <DialogTitle style={{ backgroundColor: buttonColor, color: "#FFFFFF" }}>
        {t("CreateTrigger")}
      </DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h6" color={status ? "green" : "red"}>
          {status ? "ON" : "OFF"}
        </Typography>
        <Switch
          checked={status}
          onChange={() => setStatus(!status)}
          color="primary"
        />

        <Typography variant="h6">{t("Type")}: {t(type === "single" ? "Single" : "Recurrent")}</Typography>
        <Switch
          checked={type !== "single"}
          onChange={() => setType(type === "single" ? "recurrent" : "single")}
          color="primary"
        />
        
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {type === "single" ? (
            <DateTimePicker label={t("Select Date")} value={date} onChange={handleConfirm} />
          ) : (
            <TimePicker label={t("Select Time")} value={time} onChange={handleConfirmTime} />
          )}
        </LocalizationProvider>

        {type !== "single" && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, auto)', gap: '10px', justifyContent: 'center' }}>
            {Object.keys(weekdays).map((day) => (
              <FormControlLabel
                key={day}
                control={<Checkbox checked={weekdays[day]} onChange={() => handleWeekdayChange(day)} />}
                label={t(day)}
              />
            ))}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalVisible(false)} color="primary">
          {t("Cancel")}
        </Button>
        <Button onClick={handleCreateTrigger} color="primary" disabled={!canSend}>
          {t("Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTriggerModal;